export default __webpack_public_path__ + "static/media/extension.3949ed86.png";